// extracted by extract-css-chunks-webpack-plugin
module.exports = {"permissionActor":"PermissionActor__permissionActor___fRD8r"};
    if(module.hot) {
      // 1778083494446
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  